import { ButtonV2, Text, VerticalSpace } from '@arc-ui/components';
import { ConsumerLookupProps } from '../../../types/ee-header';

const ConsumerLookup = ({ query, isMobile, isTablet }: ConsumerLookupProps) => {
  return (
    <div className="ee-consumer-lookup">
      {(isMobile || isTablet) && <VerticalSpace size="16" />}
      <Text elementType="p">Are you looking for?</Text>
      {!isMobile && !isTablet && <VerticalSpace size="16" />}
      <ButtonV2
        id="ee-search-consumerBtn"
        label="Consumer"
        buttonStyle={isMobile || isTablet ? 'compact' : 'secondary'}
        size={isMobile ? 's' : 'm'}
        href={`https://ee.co.uk/search?q=${encodeURIComponent(query ?? '')}`}
        {...(isMobile || isTablet ? {} : { isFullWidth: true })}
      />
    </div>
  );
};

export default ConsumerLookup;
